export const STORAGE_PREFIX_KEY = `oboku`
